import { forwardRef, type SVGProps } from 'react';

export type DowntickProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Downtick = forwardRef<SVGSVGElement, DowntickProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M28.47 9.76L16 22.22 3.53 9.76h24.94z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
Downtick.displayName = 'Downtick';
